/**
 * Critical + serious accessibility helpers that complement theme.js.
 * Avoid changing cart/filter/search business logic — only ARIA/focus safety.
 */
(function () {
  'use strict';

  function setDialogOpenState(el, isOpen) {
    if (!el) return;
    el.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
  }

  function observeDrawer(el) {
    if (!el || el.dataset.a11yDialogObserved === 'true') return;
    el.dataset.a11yDialogObserved = 'true';

    setDialogOpenState(el, el.classList.contains('is-open'));

    const observer = new MutationObserver(function () {
      setDialogOpenState(el, el.classList.contains('is-open'));
    });

    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function patchA11yHelpers() {
    const a11y = window.theme && window.theme.a11y;
    if (!a11y || a11y.__a11yCriticalPatched) return;

    const originalFocusable = a11y.focusable.bind(a11y);
    a11y.focusable = function (container) {
      return originalFocusable(container).filter(function (element) {
        const tabindex = element.getAttribute('tabindex');
        return tabindex !== '-1';
      });
    };

    a11y.autoFocusLastElement = function () {
      if (!window.a11y || !window.a11y.lastElement) return;
      setTimeout(function () {
        try {
          window.a11y.lastElement.focus();
        } catch (e) {
          // Element may have been removed from the DOM
        }
      });
    };

    a11y.__a11yCriticalPatched = true;
  }

  function observeFilterDialog(el) {
    if (!el || el.getAttribute('role') !== 'dialog' || el.dataset.a11yDialogObserved === 'true') return;
    el.dataset.a11yDialogObserved = 'true';

    const sync = function () {
      const isOpen = el.classList.contains('expanded') || el.classList.contains('is-open');
      el.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    };

    sync();
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    patchA11yHelpers();
    observeDrawer(document.querySelector('cart-drawer'));
    observeDrawer(document.querySelector('header-drawer[data-drawer]'));
    document.querySelectorAll('[data-collection-sidebar][role="dialog"]').forEach(observeFilterDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
